import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { DirectivesModule } from 'directives/directives.module';
import { UpdatePlanOptionsPage } from './update-plan-options';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [UpdatePlanOptionsPage],
    imports: [PagesModule, ComponentsModule, DirectivesModule]
})
export class UpdatePlanOptionsPageModule { }
